import Vue from 'vue'
import Vuex from 'vuex'
import user from './user';
import comm from './comm';
import email from './email';
import surveys from './surveys';
import surveyForm from './surveyForm';
import reservations from './reservations';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: {
      idToken: null,
      userId: null
    },
    appInited: false,
  },
  actions: {
    appInited({commit}){
      commit('mInitApp');
    },
    login({ commit }, authData) {
      console.log(authData);
      // TODO: make api call here
      commit("authUser", {
        // for testing
        token: "testtoken123",
        userId: "testUser"
      });
    }
  },
  mutations: {
    mInitApp(state) {
      state.appInited = true;
    },
    authUser(state, userData) {
      state.auth.idToken = userData.token;
      state.auth.userId = userData.userId;
    }
  },
  modules: {
    user,
    comm,
    email,
    surveys,
    surveyForm,
    reservations,
  }
})
